<template>
  <button
    class="complete-btn-container"
    :class="type"
    v-bind="$attrs"
    v-on="$listeners"
    @click="clickBtn"
  >
    {{ text }}
    <slot name="content" />
  </button>
</template>
<script>
export default {
  name: 'CompleteButton',
  props: {
    text: {
      type: String,
      default: '确定',
    },
    type: {
      type: String,
      default: 'confirm',
    },
  },
  methods: {
    clickBtn() {
      this.$emit('clickBtn');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.complete-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 28px;
  height: 36px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  &.confirm {
    background: linear-gradient(to right, #febf5d, #e15d3f);
    color: #fff;
    &:hover{
      background: linear-gradient( 270deg, #EA3E17 0%, #FFB139 100%);
    }
  }
  &.cancel {
    border: 1px solid #d9d9d9;
    color: $modal-label-text-color;
  }
  &:disabled {
    background: $btn-disabled-bg-color;
    color: $btn-disabled-color;
    border-color: $btn-disabled-bg-color;
    cursor: not-allowed;
  }
}
</style>
